<template>
  <PlatformLayout :useOverlay="overlay">
    <v-card rounded max-width="1366" class="d-block mx-auto">
      <v-card-title>
        <v-container fluid class="d-flex justify-space-between pa-0">
          <h5 class="text-h5 font-weight-bold text-left">
            Clientes
            <v-icon large>mdi-account-group</v-icon>
          </h5>
          <div>
            <v-btn
              color="primary"
              class="mr-lg-1"
              @click="navigate('/platform/clientes/nuevo-cliente')"
            >
              <v-icon>mdi-plus</v-icon>&nbsp;AGREGAR
            </v-btn>
            <v-btn @click="navigate('/platform/clientes/importacion-clientes')">
              <v-icon>mdi-file-excel-outline</v-icon>Importar Excel
            </v-btn>
          </div>
        </v-container>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :headers="headers"
          :items="clientes"
          :search="search"
          :footer-props="{
            itemsPerPageText: 'El. por página',
            itemsPerPageAllText: 'Todo',
          }"
        >
          <template v-slot:top>
            <v-text-field v-model="search" label="Buscar"></v-text-field>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn
              fab
              small
              color="accent"
              @click="navigate('/platform/clientes/' + item.id)"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <template v-slot:item.clave="{ item }">
            {{ item.clave | uppercase }}
          </template>
          <template v-slot:item.ultima_cotizacion="{ item }">
            {{ item.ultima_cotizacion | date }}
          </template>
          <template v-slot:item.valor_facturado="{ item }">
            {{ item.valor_facturado | currency }}
          </template>
          <template v-slot:no-data
            >No hay datos para mostrar (&gt;.&lt;)</template
          >
        </v-data-table>
      </v-card-text>
    </v-card>
  </PlatformLayout>
</template>

<script>
import PlatformLayout from "../components/PlatformLayout.vue";
import { httpGet } from "../services/apiService";

export default {
  name: "Clientes",
  components: {
    PlatformLayout,
  },
  data() {
    return {
      search: "",
      dialog: false,
      dialogDelete: false,
      headers: [
        { text: "ID Cliente", value: "id" },
        { text: "ID SAP", value: "clave" },
        { text: "Cliente", value: "nombre" },
        { text: "Fecha ult. cotización", value: "ultima_cotizacion" },
        { text: "Valor facturado", value: "valor_facturado" },
        { text: "Actions", value: "actions", sortable: false },
      ],
      clientes: [],
      overlay: false,
    };
  },
  methods: {
    async get() {
      this.overlay = true;
      const { data } = await httpGet("/clientes");
      for (const r of data?.data) {
        const cliente = {
          ...r.attributes,
          id: r.id,
          ultima_cotizacion: this.resolveLastQuotation(r),
          valor_facturado: this.resolveGrandTotal(r),
        };
        this.clientes.push(cliente);
      }
      this.overlay = false;
    },
    navigate(path) {
      this.$router.push(path);
    },
    notify() {
      this.$toasted.show("Sección en construcción", { type: "info" });
    },
    resolveLastQuotation(item) {
      if (
        item?.attributes?.cotizaciones == null ||
        item?.attributes?.cotizaciones?.data.length == 0
      ) {
        return null;
      }
      const allDates = item.attributes.cotizaciones.data.map(
        (c) => c.attributes.fecha_elaboracion
      );
      const sorted = allDates.sort((a, b) => new Date(b) - new Date(a));
      return sorted[0];
    },
    resolveGrandTotal(item) {
      if (
        item?.attributes?.cotizaciones == null ||
        item?.attributes?.cotizaciones?.data.length == 0
      ) {
        return "---";
      }
      const allTotals = item.attributes.cotizaciones.data.map(
        (c) => c.attributes.total
      );
      return allTotals.reduce((p, c) => p + c, 0);
    },
  },
  created() {
    this.get();
  },
};
</script>